import gsap from "gsap";

const builderSections = document.querySelectorAll( "section.product-builder" );

builderSections.forEach( ( section ) => {
  /**
   * Data and Vars
   */
  const ITEM_DATA = [
    {
      name: "CellFAB One E",
      desc: "End-to-End Enclosed Processing",
      features: [
        `Fully integrated from sample intake to final product dispensing `,
        `Supports GMP digital traceability with 21 CFR Part 11-compliant interface`,
        `Temperature-controlled centrifuge chamber and cultivation module`,
        `Gas system supports CO₂, compressed air, and O₂ and N₂ mixing`,
        `Real-time digital monitoring of volume, pressure, weighing, and protocol progress`,
        `GUI-controlled touchscreen with barcode scanning and secure card login`,
      ],
      tooltip: "e",
      els: [
        {
          selector: "ps-4",
          x: 746.199,
          y: 56,
          width: 265.474,
          height: 408.778,
        },
        { selector: "ps-6", x: 745, y: 446, width: 237.791, height: 164.268 },
      ],
      svgs: {
        mobile: "cellfab-one-e-mobile",
        mobile_outline: "cellfab-one-e-mobile-outline",
      },
    },
    {
      name: "CellFAB One M",
      desc: "Microbead Magnetic Selection and Activation",
      features: [
        `The CellFAB One E is the foundational platform upon which the CellFAB One M is built `,
        `Specially designed for high-efficiency micro-scale magnetic bead separation in a continuous flow format`,
        `Enables both cell selection and activation with microbeads`,
        `Direct inline injection reduces damage and increases yield`,
        `Auto-controlled magnetic field for precision and consistency`,
      ],
      tooltip: "m",
      els: [
        {
          selector: "ps-0",
          x: 910.2,
          y: 187.4,
          width: 50.7877,
          height: 42.8727,
        },
        {
          selector: "ps-2",
          x: 682.2,
          y: 229.4,
          width: 110.395,
          height: 234.011,
        },
        { selector: "ps-4", x: 759, y: 53, width: 265.474, height: 408.778 },
        { selector: "ps-5", x: 651, y: 449, width: 345.765, height: 158.972 },
      ],
    },
    {
      name: "CellFAB One I",
      desc: "Integrated Expansion Support for G-Rex and Cell Bags",
      features: [
        `The CellFAB One E is the foundational platform upon which the CellFAB One I is built `,
        `Compatible with G-Rex and cell bags for higher-volume cell expansion`,
        `Bridges in-chamber control with external incubation environments`,
        `Maintains closed-system sterility with secure media exchange and transfer`,
      ],
      tooltip: "p",
      els: [
        {
          selector: "ps-1",
          x: 657,
          y: 295.844,
          width: 325.803,
          height: 261.68,
        },
        {
          selector: "ps-4",
          x: 953.184,
          y: 144,
          width: 265.762,
          height: 409.22,
        },
      ],
    },
    {
      name: "CellFAB One N",
      desc: "Nanobead Magnetic Selection and Activation",
      features: [
        `The CellFAB One E is the foundational platform upon which the CellFAB One N is built `,
        `Specially designed for high-efficiency nano-scale magnetic bead separation in a continuous flow format`,
        `Enables both cell selection and activation with nanobeads`,
        `Direct inline injection reduces damage and increases yield`,
        `Auto-controlled magnetic field for precision and consistency`,
      ],
      tooltip: "n",
      els: [
        {
          selector: "ps-3",
          x: 686.602,
          y: 55.3984,
          width: 124.17,
          height: 407.33,
        },
        {
          selector: "ps-4",
          x: 777.801,
          y: 53,
          width: 265.474,
          height: 408.778,
        },
        { selector: "ps-5", x: 671, y: 449, width: 345.765, height: 158.972 },
      ],
    },
    {
      name: "CellFAB One Q",
      desc: "Inline Sampling and Cell Counting for Seamless QC",
      features: [
        `The CellFAB One E is the foundational platform upon which the CellFAB One Q is built `,
        `Closed-system sampling and real-time cell counting capabilities`,
        `Supports active monitoring of cell concentration during expansion`,
      ],
      tooltip: "q",
      els: [
        {
          selector: "ps-4",
          x: 592,
          y: 144,
          width: 265.762,
          height: 409.22,
        },
        { selector: "ps-7", x: 864.816, y: 320, width: 299, height: 233 },
      ],
    },
    {
      name: "CellFAB One MN",
      desc: "Microbead and Nanobead Capabilities for Ultimate Selection and Activation Flexibility",
      features: [
        `The CellFAB One E is the foundational platform upon which the CellFAB One MN is built `,
        `Combines medium exchange, magnetic bead separation, and formulation in a single, closed system`,
        `Specially designed for high-efficiency micro- and nano-scale magnetic bead separation in a continuous flow format`,
        `Enables both cell selection and activation with micro and nanobeads`,
      ],
      tooltip: "mn",
      els: [
        { selector: "ps-0", x: 928, y: 188, width: 50.7877, height: 42.8727 },
        {
          selector: "ps-3",
          x: 686.602,
          y: 55.3984,
          width: 124.17,
          height: 407.33,
        },
        {
          selector: "ps-4",
          x: 777.801,
          y: 53,
          width: 265.474,
          height: 408.778,
        },
        { selector: "ps-5", x: 671, y: 449, width: 345.765, height: 158.972 },
      ],
    },
  ];
  let possibleSystems = [];
  let currentModel;
  let isBuilding = false;
  /**
   * DOM elements
   */
  const imgs = section.querySelectorAll( "svg rect[id*='ps-']" );
  const outlines = section.querySelectorAll( "svg path[data-rect*='ps-']" );
  const builderPanel = document.querySelector( ".builder-panel" );
  const resetBtn = document.getElementById( "builder-reset" );
  const card = section.querySelector( ".info-card" );
  const mobileCard = section.querySelector( ".mobile-card" );
  const mobileInfoCard = section.querySelector( ".mobile-info-card" );
  const form = document.getElementById( "assembler-form" );
  const tooltipGroups = section.querySelectorAll( "g.tooltips g" );
  const rec = section.querySelector( ".rec" );
  const mobileSVG = document.querySelector( ".mobile-svgs" );


  /**
   * FUNCTIONS
   */

  // main animation

  function renderMobileSVGs ( data ) {
    document.querySelectorAll( ".mobile-svg-item" ).forEach( ( el ) => {
      el.style.display = el.dataset.name === data.name ? "flex" : "none";
    } );
    document.querySelectorAll( ".mobile-outline-item" ).forEach( ( el ) => {
      el.style.display = el.dataset.name === data.name ? "flex" : "none";
    } );
  }

  function buildSystem ( index ) {
    if ( isBuilding ) {
      console.log( "already building" );
      return;
    }


    isBuilding = true;
    currentModel = index;
    const data = ITEM_DATA[ index ];
    let actives = [];
    tooltipGroups.forEach( ( group ) => {
      group.classList.remove( "active" );
    } );
    data.els.forEach( ( item ) => {
      actives.push( item.selector );
    } );

    console.log( "actives are", actives );
    outlines.forEach( ( outline ) => {
      if ( actives.includes( outline.dataset.rect ) ) {
        outline.setAttribute( "fill", "#F7E783" );
        outline.setAttribute( "stroke", "#F7E783" );
      } else {
        outline.setAttribute( "fill", "#A0A0A0" );
        outline.setAttribute( "stroke", "#FFFFFF" );
      }
    } );
    imgs.forEach( ( img ) => {
      if ( actives.includes( img.id ) ) {
        img.setAttribute( "opacity", "1" );
        const itemData = data.els.find( ( item ) => item.selector === img.id );
        console.log( "itemData is", itemData );
        gsap.to( img, {
          attr: {
            x: itemData.x,
            y: itemData.y,
            width: itemData.width,
            height: itemData.height,
          },
          opacity: 1,
          duration: 1,
          ease: "power2.inOut",
          onComplete: () => {
            // show tooltips
            // show tooltips
            if ( data.tooltip ) {
              tooltipGroups.forEach( ( group ) => {
                if ( group.id == data.tooltip ) {
                  group.classList.add( "active" );
                }
              } );
            }
            isBuilding = false;
          },
        } );
        // img.setAttribute("x", itemData.x);
        // img.setAttribute("y", itemData.y);
      } else {
        gsap.to( img, {
          opacity: 0,
          duration: 0,
          attr: {
            opacity: 0,
          },
        } );
      }
    } );

    // fill out card
    card.querySelector( "h4" ).textContent = data.name;
    card.querySelector( "p" ).textContent = data.desc;
    card.querySelector( "ul" ).innerHTML = data.features
      .map( ( feature ) => `<li>${ feature }</li>` )
      .join( "" );
    card.querySelector(
      "a"
    ).href = `/contact?message=I want to learn more about ${ data.name }.`;
    gsap.to( card, {
      x: "0",
      duration: 1,
      ease: "power2.inOut",
    } );
    // fill out mobile card
    mobileInfoCard.querySelector( "h4" ).textContent = data.name;
    mobileInfoCard.querySelector( "p" ).textContent = data.desc;
    mobileInfoCard.querySelector( "ul" ).innerHTML = data.features
      .map( ( feature ) => `<li>${ feature }</li>` )
      .join( "" );
    mobileInfoCard.querySelector(
      "a"
    ).href = `/contact?message=I want to learn more about ${ data.name }.`;

    if ( window.innerWidth < 1024 ) {
      mobileCard.classList.remove( "hidden" );
      mobileInfoCard.classList.remove( "hidden" );
    }

    // mobileInfoCard.style.display = window.innerWidth < 1024 ? "block" : "none";
    // gsap.fromTo(
    //   mobileInfoCard,
    //   { y: -200, opacity: 0 },
    //   { y: 0, opacity: 1, duration: 1, ease: "power2.out" }
    // );

    // button classes
    const buttons = section.querySelectorAll( ".btns button" );
    buttons.forEach( ( btn ) => {
      if ( btn.getAttribute( "data-index" ) == index ) {
        btn.classList.add( "active" );
      } else {
        btn.classList.remove( "active" );
      }
    } );
    renderMobileSVGs( data );
    mobileCard.classList.add( "active" );
    form.classList.add( "hidden" );
    mobileSVG.classList.remove( "hidden" );
  }

  // main logic
  function createPossibleSystems ( data ) {
    possibleSystems = [];

    /**
     * for testing all systems
     */
    if ( 1 > 2 ) {
      possibleSystems.push( "CellFAB One E" );
      possibleSystems.push( "CellFAB One M" );
      possibleSystems.push( "CellFAB One N" );
      possibleSystems.push( "CellFAB One I" );
      possibleSystems.push( "CellFAB One Q" );
      possibleSystems.push( "CellFAB One MN" );
      return;
    }

    const onLineCell = data[ "on-line-cell" ];
    const incubationFormat = data[ "incubation-format" ];
    const { nanobeads, microbeads } = data;

    // Helper function to add systems based on conditions
    const addSystems = ( ...systems ) => {
      systems.forEach( system => possibleSystems.push( system ) );
    };

    // NEW LOGIC 12/16/2025
    if ( onLineCell === "yes" ) {
      handleOnLineCellYes( nanobeads, microbeads, incubationFormat, addSystems );
    } else if ( onLineCell === "no" ) {
      handleOnLineCellNo( nanobeads, microbeads, incubationFormat, addSystems );
    }

    // Handle edge cases when on-line-cell is not set
    handleEdgeCases( data, addSystems );

    // Default fallback
    if ( possibleSystems.length === 0 ) {
      possibleSystems.push( "CellFAB One E" );
    }

    console.log( "possibleSystems are", possibleSystems );
  }

  function handleOnLineCellYes ( nanobeads, microbeads, incubationFormat, addSystems ) {
    // New logic: nano + micro + in-chamber + yes to cell counting => MN, Q
    if ( nanobeads && microbeads && incubationFormat === "in-chamber" ) {
      addSystems( "CellFAB One MN", "CellFAB One Q" );
      return;
    }
    // New logic: nano + micro + grex + yes to cell counting => MN, I, Q
    if ( nanobeads && microbeads && incubationFormat === "g-rex" ) {
      addSystems( "CellFAB One MN", "CellFAB One I", "CellFAB One Q" );
      return;
    }
    if ( nanobeads && microbeads ) {
      if ( incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One MN", "CellFAB One Q" );
      } else if ( incubationFormat === "cell-bags" ) {
        addSystems( "CellFAB One MN", "CellFAB One I", "CellFAB One Q" );
      }
    } else if ( nanobeads && !microbeads ) {
      if ( incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One N", "CellFAB One Q" );
      } else if ( incubationFormat === "cell-bags" || incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One N", "CellFAB One I", "CellFAB One Q" );
      }
    } else if ( !nanobeads && microbeads ) {
      if ( incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One M", "CellFAB One Q" );
      } else if ( incubationFormat === "cell-bags" || incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One M", "CellFAB One I", "CellFAB One Q" );
      }
    } else if ( !nanobeads && !microbeads ) {
      addSystems( "CellFAB One Q", "CellFAB One I" );
    }
  }

  function handleOnLineCellNo ( nanobeads, microbeads, incubationFormat, addSystems ) {
    if ( nanobeads && microbeads ) {
      if ( incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One MN" );
      } else if ( incubationFormat === "cell-bags" || incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One MN", "CellFAB One I" );
      }
    } else if ( !nanobeads && !microbeads ) {
      if ( incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One E" );
      } else if ( incubationFormat === "cell-bags" || incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One I" );
      }
    } else if ( nanobeads && !microbeads ) {
      if ( incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One N" );
      } else if ( incubationFormat === "cell-bags" ) {
        addSystems( "CellFAB One N", "CellFAB One I" );
      } else if ( incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One I", "CellFAB One N" );
      }
    } else if ( !nanobeads && microbeads ) {
      if ( incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One M" );
      } else if ( incubationFormat === "cell-bags" || incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One M", "CellFAB One I" );
      }
    }
  }

  function handleEdgeCases ( data, addSystems ) {
    const onLineCell = data[ "on-line-cell" ];
    const incubationFormat = data[ "incubation-format" ];
    const { nanobeads, microbeads } = data;

    // When on-line-cell is not set
    if ( !onLineCell ) {
      if ( !nanobeads && microbeads && !incubationFormat ) {
        addSystems( "CellFAB One M" );
      }
      if ( nanobeads && microbeads && !incubationFormat ) {
        addSystems( "CellFAB One MN" );
      }
      if ( nanobeads && !microbeads && !incubationFormat ) {
        addSystems( "CellFAB One N" );
      }
      if ( nanobeads && microbeads && incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One MN" );
      }
      if ( !nanobeads && !microbeads && incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One I" );
      }
      if ( !nanobeads && !microbeads && incubationFormat === "cell-bags" ) {
        addSystems( "CellFAB One I" );
      }
      if ( !nanobeads && microbeads && incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One M" );
      }
      if ( nanobeads && !microbeads && incubationFormat === "in-chamber" ) {
        addSystems( "CellFAB One N" );
      }
      // New logic - 12/23/2025
      if ( !nanobeads && microbeads && incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One M", "CellFAB One I" );
      }
      if ( !nanobeads && microbeads && incubationFormat === "cell-bags" ) {
        addSystems( "CellFAB One M", "CellFAB One I" );
      }
      if ( nanobeads && microbeads && incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One MN", "CellFAB One I" );
      }
      if ( nanobeads && microbeads && incubationFormat === "cell-bags" ) {
        addSystems( "CellFAB One MN", "CellFAB One I" );
      }
      if ( nanobeads && !microbeads && incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One N", "CellFAB One I" );
      }
      if ( nanobeads && !microbeads && incubationFormat === "cell-bags" ) {
        addSystems( "CellFAB One N", "CellFAB One I" );
      }
    }

    // When on-line-cell is explicitly "no"
    if ( onLineCell === "no" ) {
      if ( nanobeads && !microbeads && !incubationFormat ) {
        addSystems( "CellFAB One N" );
      }
      if ( nanobeads && microbeads && !incubationFormat ) {
        addSystems( "CellFAB One MN" );
      }
      if ( !nanobeads && !microbeads && incubationFormat === "g-rex" ) {
        addSystems( "CellFAB One I" );
      }
      if ( !nanobeads && microbeads && !incubationFormat ) {
        addSystems( "CellFAB One M" );
      }
    }
  }

  // reset the svg
  function resetBuilder () {
    currentModel = null;
    possibleSystems = [];
    tooltipGroups.forEach( ( group ) => {
      group.classList.remove( "active" );
    } );
    setTimeout( () => {
      tooltipGroups.forEach( ( group ) => {
        group.classList.remove( "active" );
      } );
    }, 1000 );
    gsap.to( card, {
      x: "-100%",
      duration: 1,
      ease: "power2.inOut",
      onComplete: () => {
        card.querySelector( "h4" ).textContent = "";
        card.querySelector( "p" ).textContent = "";
        card.querySelector( "ul" ).innerHTML = "";
      },
    } );
    // gsap.to(mobileInfoCard, {
    //   y: -200,
    //   opacity: 0,
    //   duration: 0.4,
    //   ease: "power2.inOut",
    //   onComplete: () => {
    //     mobileInfoCard.querySelector("h4").textContent = "";
    //     mobileInfoCard.querySelector("p").textContent = "";
    //     mobileInfoCard.querySelector("ul").innerHTML = "";
    //   },
    // });
    mobileInfoCard.classList.add( "hidden" );
    mobileCard.classList.add( "hidden" );
    mobileInfoCard.querySelector( "h4" ).textContent = "";
    mobileInfoCard.querySelector( "p" ).textContent = "";
    mobileInfoCard.querySelector( "ul" ).innerHTML = "";

    imgs.forEach( ( img ) => {
      gsap.to( img, {
        opacity: 1,
        attr: {
          x: img.getAttribute( "data-x" ),
          y: img.getAttribute( "data-y" ),
          width: img.getAttribute( "data-width" ),
          height: img.getAttribute( "data-height" ),
        },
        duration: 1,
      } );
    } );
    outlines.forEach( ( outline ) => {
      //   gsap.to(outline, {
      //     fill: "#A0A0A0",
      //     stroke: "#FFFFFF",
      //     duration: 0.5,
      //     ease: "power2.inOut",
      //   });
      outline.setAttribute( "fill", "#A0A0A0" );
      outline.setAttribute( "stroke", "#FFFFFF" );
    } );
    tooltipGroups.forEach( ( group ) => {
      group.classList.remove( "active" );
    } );
    mobileCard.classList.remove( "active" );
    mobileSVG.classList.add( "hidden" );
    form.classList.remove( "hidden" );
  }

  //create the btns for the possible systems
  function createButtons () {
    section.querySelector( ".btns" ).innerHTML = "";
    if ( possibleSystems.length > 0 ) {
      rec.textContent = `Recommended System(s)`;
      ITEM_DATA.forEach( ( data, i ) => {
        if ( possibleSystems.includes( data.name ) ) {
          const btn = document.createElement( "button" );
          btn.classList.add(
            "rounded-full",
            "p-2",
            "px-4",
            "transition-colors",
            "duration-300",
            "bg-darker-gray",
            "text-white",
            // "hover:bg-white",
            // "hover:text-darker-gray",
            "mr-2",
            "mb-2",
            "cursor-default"
          );
          btn.setAttribute(
            "id",
            `system-${ data.name.toLowerCase().replaceAll( " ", "-" ) }`
          );
          btn.setAttribute( "data-index", i );
          btn.textContent = data.name;
          btn.addEventListener( "click", () => {
            // if(btn.classList.contains('active')) {
            //   alert('already active')
            //   return;
            // }
            const index = btn.getAttribute( "data-index" );
            console.log( "index is", index );
            console.log( "btn clicked", data.name );
            if ( index == currentModel ) {
              return;
            }
            buildSystem( i );
          } );
          section.querySelector( ".btns" ).appendChild( btn );
          if ( possibleSystems.length == 1 ) {
            btn.click();
            btn.classList.add( "active" );
          }
        }
      } );
      // select the first button if multiple options
      if ( possibleSystems.length > 1 ) {
        // Get all buttons with a data-index
        const buttons = Array.from( section.querySelectorAll( '.btns button[data-index]' ) );

        if ( buttons.length > 0 ) {
          // Sort by the numeric value of data-index
          const lowestBtn = buttons.sort( ( a, b ) => {
            return Number( a.dataset.index ) - Number( b.dataset.index );
          } )[ 0 ];

          // Click the one with the lowest index
          lowestBtn.click();
        }
      }


      mobileCard.classList.remove( "mt-6", "mt-20", "mt-32" );
      if ( possibleSystems.length === 1 ) {
        mobileCard.classList.add( "mt-6" );
      } else if ( possibleSystems.length === 2 ) {
        mobileCard.classList.add( "mt-20" );
      } else if ( possibleSystems.length >= 3 ) {
        mobileCard.classList.add( "mt-32" );
      }
    } else {
      rec.textContent = `No Recommended System(s) Found`;
    }
  }

  // show top builder panel
  function showBuilderPanel () {
    if ( window.innerWidth < 1024 ) {
      builderPanel.classList.remove( "relative" );
      builderPanel.classList.add( "absolute", "inset-0", "h-fit" );
      // mobileCard.classList.remove("mt-[-95px]");
      // mobileCard.classList.add( 'mt-6' );
    }
    gsap.to( builderPanel, {
      display: "flex",
      duration: 0,
    } );
  }

  // hide top builder panel
  function hideBuilderPanel () {
    if ( window.innerWidth < 1024 ) {
      builderPanel.classList.remove( "absolute", "inset-0", "h-fit" );
      builderPanel.classList.add( "relative" );
      mobileCard.classList.add( "hidden" );
      mobileInfoCard.classList.add( "hidden" );
      // mobileCard.classList.remove( 'mt-6' );
    }
    gsap.to( builderPanel, {
      display: "none",
      duration: 0,
    } );
  }

  /**
   * Tie functions to DOM element events
   */
  form.addEventListener( "submit", ( e ) => {
    e.preventDefault();
    console.log( "form submitted" );
    const formData = new FormData( form );
    const data = Object.fromEntries( formData );
    console.log( data );

    createPossibleSystems( data );
    createButtons();
    showBuilderPanel();
  } );
  resetBtn.addEventListener( "click", () => {
    resetBuilder();
    hideBuilderPanel();
  } );
} );
